import PropTypes from 'prop-types';
import Masonry from 'react-masonry-css';

import {DesignedHeader} from '../../commonComponents/DesignedHeader';

const GalleryScreen = ({data}) => {
  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    700: 2,
    500: 2,
  };

  return (
    <div className={'w-full flex flex-col lg:p-20 p-4 justify-center items-center bg-primary-50'} data-aos={'fade-up'}>
      <div className={'max-w-7xl w-full'}>
        <h1 className={'italianno-regular text-primary-900 lg:text-7xl text-5xl'} data-aos={'fade-up'}>
          <DesignedHeader title={'Gallery'} />
        </h1>
        <div className={'mx-auto lg:p-10 p-3'} data-aos={'fade-up'}>
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className={'flex justify-center'}
            columnClassName={'lg:pl-4 mr-4'}
          >
            {data.images.map((item, index) => (
              <img key={index} src={item.image} alt={'image1'} className={'mb-4 lg:rounded-xl rounded-lg transition-transform ease-in-out duration-500 hover:scale-105'} />
            ))}
          </Masonry>
        </div>
      </div>
    </div>
  );
};

GalleryScreen.propTypes = {
  data: PropTypes.shape({
    images: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default GalleryScreen;
